import View, {
  SessionExpirationWatcherContainerProps,
  SessionExpirationWatcherProps as _SessionExpirationWatcherProps, WatcherState
} from "./session-expiration-watcher-view";
import {useEffect, useState} from "react";
import {getClientId, getUserUIBase} from "../../api/ApiImplementation";
import {asDukeLocale} from "../localize/localize-view";
import {useIntl} from "react-intl";
import {LogoutCompleted} from "../../model/LogoutCompleted";

const PromptRenewalDelta = 300000;
const BlockUIDelta = 1000;

export interface SessionExpirationWatcherProps extends Omit<_SessionExpirationWatcherProps, keyof SessionExpirationWatcherContainerProps> {
  logoutCompleted?: LogoutCompleted;
  /**
   * Time in millis that the current authentication will remain valid
   */
  authenticationIsValidUntil: number;
}
function SessionExpirationWatcher(props: SessionExpirationWatcherProps){
  const {
    logoutCompleted,
    authenticationIsValidUntil,
      ...other
  } = props;
  const [expiresIn, setExpiresIn] = useState<number | undefined>(undefined);
  const [showPrompt, setShowPrompt] = useState<WatcherState>(WatcherState.OK);
  const [promptDismissed, setPromptDismissed] = useState<boolean>(false);

  const intl = useIntl();
  /* eslint-disable no-template-curly-in-string */
  /* tslint:disable:no-template-curly-in-string */
  const idp_base = getUserUIBase().replace(
      "${locale}",
      intl.locale !== intl.defaultLocale ? "/" + asDukeLocale(intl.locale) : ""
  );
  /* tslint:enable:no-template-curly-in-string */
  /* eslint-enable no-template-curly-in-string */
  const logout = () => {
    window.location.href =
        idp_base +
        "/oauth20/signout?client_id=" +
        encodeURIComponent(getClientId());
  };


  // Handles the state
  useEffect(() => {
    let timer: any;
    let expirationTimer: any;
    if (logoutCompleted) {
      setShowPrompt(WatcherState.OK);
    } else {
      if (other.externalLogout === true) {
        setShowPrompt(WatcherState.BLOCK);
      } else {
        const now = new Date().getTime();
        const timeToPrompt =
            authenticationIsValidUntil - now - PromptRenewalDelta;
        const timeToBlock = authenticationIsValidUntil - now - BlockUIDelta;
        let newState;
        if (timeToPrompt <= 0) {
          if (timeToBlock <= 0) {
            newState = WatcherState.BLOCK;
          } else {
            newState = WatcherState.PROMPT;
            timer = setTimeout(() => {
              setShowPrompt(WatcherState.BLOCK);
            }, timeToBlock);
          }
        } else {
          if (showPrompt) {
            newState = WatcherState.OK;
          }
          timer = setTimeout(() => {
            setShowPrompt(WatcherState.PROMPT);
          }, timeToPrompt);
        }

        // takes care of updating the countdown number
        if (
            (newState && newState === WatcherState.PROMPT) ||
            showPrompt === WatcherState.PROMPT
        ) {
          expirationTimer = setInterval(() => {
            setExpiresIn(
                Math.round(
                    (authenticationIsValidUntil - new Date().getTime()) / 1000
                )
            );
          }, 1000);
        } else {
          setExpiresIn(undefined);
        }
        if (newState) {
          setShowPrompt(newState);
        }
      }
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
      if (expirationTimer) {
        clearInterval(expirationTimer);
      }
    };
  }, [logoutCompleted, authenticationIsValidUntil, showPrompt, other.externalLogout]);
  return <View
      {...other}
      expiresIn={expiresIn}
      setExpiresIn={setExpiresIn}
      showPrompt={showPrompt}
      setShowPrompt={setShowPrompt}
      promptDismissed={promptDismissed}
      setPromptDismissed={setPromptDismissed}
      logout={logout}
      intl={intl}
  />
}
export default SessionExpirationWatcher;
